import { RichText } from '@wordpress/block-editor';

export default function save( { attributes } ) {
	const {
		accordionQuestion,
		accordionAudioAnswer,
		accordionAnswerType,
		accordionAnswer,
		accordionVideoAnswer,
	} = attributes;

	return (
		<div className="ask__single__accordion">
			<div className="ask__accordion ask-faq">
				<RichText.Content
					className="title"
					value={ accordionQuestion }
					tagName="span"
				/>
				<div>
					<span className="ask__closed__icon">
						<svg
							width="15"
							height="15"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 512 512"
						>
							<path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
						</svg>
					</span>
					<span className="ask__open__icon">
						<svg
							width="15"
							height="15"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 512 512"
						>
							<path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z" />
						</svg>
					</span>
				</div>
			</div>
			<>
				{ ( () => {
					if ( accordionAnswerType === 'text' ) {
						return (
							<div className="ask__accordion__panel">
								<RichText.Content
									value={ accordionAnswer }
									tagName="p"
								/>
							</div>
						);
					} else if ( accordionAnswerType === 'audio' ) {
						return (
							<div className="ask__accordion__panel">
								<div className="ask__audio audio-player">
									<div className="loader animatedPlay">
										<span className="stroke"></span>
										<span className="stroke"></span>
										<span className="stroke"></span>
										<span className="stroke"></span>
										<span className="stroke"></span>
										<span className="stroke"></span>
										<span className="stroke"></span>
									</div>
									<audio
										loop
										src={ accordionAudioAnswer }
										className="audio-play"
									></audio>
									<div className="slider_container">
										<div className="current-time">
											00:00
										</div>
										<input
											type="range"
											min="1"
											max="100"
											value="0"
											className="seek_slider audio-volume"
										/>
										<div className="total-duration">
											00:00
										</div>
									</div>

									<div className="slider_container">
										<svg
											width="20px"
											height="20px"
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 448 512"
										>
											<path d="M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM412.6 181.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z" />
										</svg>
										<input
											type="range"
											min="1"
											max="100"
											value="99"
											className="volume_slider audio-duration"
										/>
										<svg
											width="20px"
											height="20px"
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 640 512"
										>
											<path d="M533.6 32.5C598.5 85.3 640 165.8 640 256s-41.5 170.8-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z" />
										</svg>
									</div>

									<div className="buttons">
										<div className="playpause-track play-audio">
											<svg
												width="40px"
												height="40px"
												xmlns="http://www.w3.org/2000/svg"
												viewBox="0 0 384 512"
											>
												<path d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z" />
											</svg>
											play
										</div>
									</div>
								</div>
							</div>
						);
					} else if ( accordionAnswerType === 'video' ) {
						return (
							<div className="ask__accordion__panel">
								<video
									controls
									loop
									src={ accordionVideoAnswer }
								></video>
							</div>
						);
					}
				} )() }
			</>
		</div>
	);
}
